const API_URL = import.meta.env.VITE_APP_API_URL || 'http://localhost:5000/api';

class ApiService {
  constructor() {
    this.baseUrl = API_URL;
  }

  getHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;
    const headers = this.getHeaders();
    
    try {
      const response = await fetch(url, {
        ...options,
        headers: { ...headers, ...options.headers }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'API request failed');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Dashboard
  getDashboardStats() {
    return this.request('/dashboard/stats');
  }

  // Appointments
  getAppointments(params) {
    return this.request('/appointments?' + new URLSearchParams(params));
  }

  createAppointment(data) {
    return this.request('/appointments', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  updateAppointment(id, data) {
    return this.request(`/appointments/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  // Communications
  getMessages(params) {
    return this.request('/communications/messages?' + new URLSearchParams(params));
  }

  sendMessage(data) {
    return this.request('/communications/messages', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  // Analytics
  getAnalytics(timeframe) {
    return this.request(`/analytics?timeframe=${timeframe}`);
  }

  // Customers
  getCustomers(params) {
    return this.request('/customers?' + new URLSearchParams(params));
  }

  createCustomer(data) {
    return this.request('/customers', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  updateCustomer(id, data) {
    return this.request(`/customers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  // Settings
  getBusinessSettings() {
    return this.request('/settings');
  }

  updateBusinessSettings(data) {
    return this.request('/settings', {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  // Integrations
  async getIntegrationSettings() {
    try {
      const response = await this.request('/integration/settings');
      return response.settings;
    } catch (error) {
      console.error('Error fetching integration settings:', error);
      throw error;
    }
  }

  async updateIntegrationSettings(settings) {
    try {
      const response = await this.request('/integration/settings', {
        method: 'PUT',
        body: JSON.stringify(settings)
      });
      return response;
    } catch (error) {
      console.error('Error updating integration settings:', error);
      throw error;
    }
  }

  generateApiKey() {
    return this.request('/integration/generate-key', {
      method: 'POST'
    });
  }
}

export default new ApiService();